import React from 'react';
import MultiSelectChipsBelow from '../CourseDetails/MultiSelectChipsBelow';
import ValidationErrorText from '../common/ValidationErrorText';
import { Box } from '@mui/material';

const DEFAULT_OPTIONS = ["CAT", "GMAT", "Not required"];

const EntranceExamRequired = ({
  label = "Entrance Exam Required",
  placeholder = "Select Entrance Exam Required",
  options = DEFAULT_OPTIONS,
  value = [],
  onChange = () => {},
  readOnly = false,
  fieldError,
  fieldErrors,
  fieldType
}) => {
  const selected = Array.isArray(value) ? value : [];

  const handleChange = (newValues) => {
    const next = Array.isArray(newValues) ? newValues : [];
    if (next.includes('Not required')) {
      onChange(['Not required']);
    } else {
      onChange(next.filter(v => v !== 'Not required'));
    }
  };

  return (
    <Box>
      <MultiSelectChipsBelow
        label={label}
        placeholder={placeholder}
        options={options}
        value={selected}
        onChange={handleChange}
        readOnly={readOnly}
        disabled={readOnly}
      />
      <ValidationErrorText error={fieldError}/>
    
    </Box>
  );
};

export default EntranceExamRequired;
